uniform sampler2D uPerlinTexture;
uniform float uTime; 

varying vec2 vUv;

void main()
{
    //Scale and animate
    vec2 smokeUv = vUv;
    smokeUv.x *= 0.5;
    smokeUv.y *= 0.3;
    smokeUv.y -= uTime * 0.03;
    //smoke
    float smoke = texture(uPerlinTexture, smokeUv).r;
    //remap
    smoke = smoothstep(0.4, 1.0, smoke);
    //edges
    //multiplying means combining them
    smoke *= smoothstep(0.0, 0.1, vUv.x);
    smoke *= smoothstep(1.0, 0.9, vUv.x);
    smoke *=smoothstep(0.0, 0.1, vUv.y);
    smoke *= smoothstep(1.0, 0.4, vUv.y);
    

    // Final color which is a blueish gray 
    gl_FragColor = vec4(0.61,0.63,0.69, smoke);

    #include <tonemapping_fragment>
    #include <colorspace_fragment>
}